// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__gW8cl","text":"footer_text__rZZDV"};